import React from 'react';
import { Pagination } from 'react-admin';

const BoxitPagination = props => (
    <Pagination rowsPerPageOptions={[10, 20, 50]} {...props} />
);

export default BoxitPagination;
